import React from 'react';
import { CoreAsyncButton, CoreTable } from '@amzn/dots-core-ui';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import {
  Host,
  /* LMSLab, */ LMSLocation,
  useClient,
  useInfiniteGetAll,
} from '$/api';
import { /* HostAddButton, */ HostColumnDefinitions } from '$/features/Hosts';

type LocationHostsTableProps = {
  // lmslab?: LMSLab,
  lmslocation?: LMSLocation;
};

export const LocationHostsTable = ({
  /* lmslab, */ lmslocation,
}: LocationHostsTableProps): JSX.Element => {
  const { hosts } = useClient();
  // const labId = lmslab?.id;
  const locationId = lmslocation?.id;
  const { data, allData, isLoading, hasNextPage, fetchNextPage } =
    // useInfiniteGetAll(hosts.resourceKey, hosts.getAll, { labId });
    useInfiniteGetAll(hosts.resourceKey, hosts.getAll, { locationId });
  return (
    <Column spacing="small">
      <Heading level={3}>
        <Row widths="fill">
          Hosts
          {/*
          <Row alignmentHorizontal="right">
            <HostAddButton lmslab={lmslab} />
          </Row>
          */}
        </Row>
      </Heading>
      <CoreTable
        fixHeaderRows
        isLoading={isLoading && !data}
        columnDefinitions={HostColumnDefinitions}
        getItemId={(item: Host) => item.id}
        items={allData}
      />
      <Row alignmentHorizontal="center">
        <CoreAsyncButton
          disabled={!hasNextPage}
          type="tertiary"
          onClick={async (): Promise<void> => {
            await fetchNextPage();
          }}
        >
          Load More
        </CoreAsyncButton>
      </Row>
    </Column>
  );
};

LocationHostsTable.defaultProps = {
  lmslocation: '',
};
